import React, { useState, useEffect } from 'react';

const ReceiverUi = ({children}) => {
  const [eventToken, seteventToken] = useState(true);

  useEffect(() => {
    const handleReceiveMessage = (event) => {
      // Check if the message is from the expected origin (main domain)
      console.log("receivedMessages:",event.data)

        // Update the receivedMessages state with the new message

        let icommingEvent = event.data
        if (icommingEvent.action === 'storeToken'){
          sessionStorage.setItem('auth_token',icommingEvent.value)
          sessionStorage.setItem('msg',icommingEvent.msg)

        }
      
    };

    // Add an event listener to listen for messages
    window.addEventListener('message', handleReceiveMessage);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('message', handleReceiveMessage);
    };
  }, []); // Run this effect only once after the component mounts

  return  eventToken ? children : null;
}
export default ReceiverUi;
